/**
 * 转换一个时间长度为分钟:秒数的格式
 * @param {number} time 需要转换格式的数值
 * @example timeToStr(78) => 1:18
 */

export const timeToStr = time => {
  return `${~~(time / 60)}:${time % 60}`;
};
